import { ReactSVG } from 'react-svg';
import { Box } from '@chakra-ui/react';

const Icon = (props) => {
  const { width, height, color, size, style, ...restProps } = props;
  const iconWidth = size || width;
  const iconHeight = size || height;

  return (
    <Box className="icon__container" display="flex" alignItems="center" justifyContent="center" {...restProps}>
      <ReactSVG
        src={props?.src}
        style={style}
        beforeInjection={(svg) => {
          svg.setAttribute('color', color);
          if (iconHeight) svg.setAttribute('height', iconHeight);
          if (iconWidth) svg.setAttribute('width', iconWidth);
        }}
      />
    </Box>
  );
};

export default Icon;
